import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { wapiTransferRepositoryBuilder } from './WapiTransferRepository'

export const wapiTransferRepository = () => {
  return wapiTransferRepositoryBuilder({
    httpService: new AxiosHttpServiceBuilder()
  })
}
